export type MembershipStatus = "ACTIVE" | "EXPIRING_SOON" | "EXHAUSTING" | "EXHAUSTED" | "EXPIRED";

export type MembershipStatusTag = {
  label: string;
  className: string;
};

export const MEMBERSHIP_STATUS_TAGS: Record<MembershipStatus, MembershipStatusTag> = {
  ACTIVE: {
    label: "ACTIVE",
    className: "bg-[#409c18] text-white",
  },
  EXPIRING_SOON: {
    label: "EXPIRING SOON",
    className: "bg-white text-[#f22626] border border-[#f22626]",
  },
  EXHAUSTING: {
    label: "EXHAUSTING",
    className: "bg-[#fffbc7] text-[#7b6300]",
  },
  EXHAUSTED: {
    label: "EXHAUSTED",
    className: "bg-[#ffe7e7] text-[#f22626]",
  },
  EXPIRED: {
    label: "EXPIRED",
    className: "bg-[#e9e9e9] text-black",
  },
};
